import { compose, composeU } from '@bem-react/core';
import {
    Button as ButtonPresenter,
    withPinClearRound,
    withSizeM,
    withThemeAction,
    withThemeNormal,
    withTypeLink,
    withTypeSubmit,
    withViewClassic
} from '@yandex-lego/components/Button/desktop';

const Button = compose(
    composeU(withThemeNormal, withThemeAction),
    withTypeLink,
    withViewClassic,
    withSizeM,
    withPinClearRound,
    withTypeSubmit
)(ButtonPresenter);

// @ts-ignore
if (typeof global.requestAnimationFrame === 'undefined') {
    // @ts-ignore
    // eslint-disable-next-line
    global.requestAnimationFrame = () => {};
}

export default Button;
